import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PersonIcon from '@mui/icons-material/Person';
import roofImg from '../assets/qrbanner/roof.svg';
import bcelBanner from '../assets/qrbanner/bcellogo.svg';
import onepayLogo from '../assets/qrbanner/onepaylogo.svg';
import supportQr from '../assets/qrbanner/supportqr.png';
import laoqrCenter from '../assets/qrbanner/ic_laoqr.png';

const BRAND_RED = '#E31B23';

const QRStyledCard = ({ qrString, mcname = 'AoneShop', username = 'MERCHANT', size = 240 }) => {
  if (!qrString) return null;

  return (
    <div
      className="qr-styled-wrapper"
      style={{
        width: '100%',
        maxWidth: 430,
        margin: '0 auto',
        fontFamily: '"Noto Sans Lao", "Noto Sans Thai", -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
        position: 'relative',
        borderRadius: 32,
        overflow: 'hidden',
        background: BRAND_RED,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
      }}
    >
      {/* 1. Official BCEL Banner */}
      <div style={{ width: '100%', padding: '12px 0 8px', display: 'flex', justifyContent: 'center' }}>
        <img src={bcelBanner} alt="BCEL Bank" style={{ height: 28, width: 'auto' }} />
      </div>

      {/* 2. Roof & OnePay Badge */}
      <div style={{ position: 'relative', width: '100%', height: 110, marginTop: 10 }}>
        <div
          style={{
            position: 'absolute',
            top: -20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 20,
            width: 84,
            height: 84,
            background: 'white',
            borderRadius: '50%',
            padding: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid white',
            boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
          }}
        >
          <img src={onepayLogo} alt="OnePay" style={{ width: '100%', height: 'auto' }} />
        </div>
        <div style={{ position: 'absolute', bottom: 0, width: '100%', zIndex: 10 }}>
          <img src={roofImg} alt="" style={{ width: '100%', display: 'block' }} />
        </div>
      </div>

      {/* 3. White Card */}
      <div
        style={{
          background: 'white',
          margin: '0 20px 20px',
          borderRadius: '0 0 40px 40px',
          padding: '0 10px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div
          style={{
            background: BRAND_RED,
            width: 'calc(100% + 20px)',
            margin: '0 -10px 20px',
            padding: '16px 20px',
            borderRadius: 20,
            color: 'white',
            textAlign: 'center',
            fontWeight: 700,
            fontSize: '1.2rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}
        >
          {mcname}
        </div>

        <div
          style={{
            padding: 12,
            borderRadius: 24,
            background: 'white',
            border: '1.5px solid #eee',
            marginBottom: 15
          }}
        >
          <QRCodeSVG
            value={qrString}
            size={size}
            level="H"
            imageSettings={{
              src: laoqrCenter,
              height: Math.round(size * 0.2),
              width: Math.round(size * 0.2),
              excavate: true
            }}
          />
        </div>

        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: '#333',
            marginBottom: 10
          }}
        >
          ຮອງຮັບ / Supports QR:
        </div>
        <img src={supportQr} alt="Payment Support" style={{ width: '92%', height: 'auto' }} />
      </div>

      {/* 4. Bottom Merchant ID */}
      <div
        style={{
          paddingBottom: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          color: 'white',
          fontWeight: 800,
          fontSize: '1.2rem',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}
      >
        <PersonIcon style={{ fontSize: 20, color: 'white' }} />
        {username}
      </div>
    </div>
  );
};

export default QRStyledCard;
